export default {
   setAnimations({ commit }, animations) {
      commit('setAnimations', animations);
    },
    setSaving({ commit }, saving ) {
      commit('setSaving', saving);
    },
  
};
